export const ADD_VARIANT_DATA = "ADD_VARIANT_DATA";
export const GET_VARIANT_DATA = "ADD_VARIANT_DATA";
export const REMOVE_VARIANT_DATA = "ADD_VARIANT_DATA";
